/* Stylesheet */

.time_period {
  .label_container {
    display: flex;
    justify-content: space-between;
    color: var(--ion-color-text-secondary);

    .value {
      font-size: 14px;
    }
  }
}
